<!--
 * @Description:
 * @Author: PF
 * @Date: 2022-10-08 09:10:31
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-10-11 18:44:59
 * @FilePath: \ZHXY_VUE3.0\src\App.vue
-->
<template>
  <div class="layout_main">
    <RouterView />
  </div>
</template>
<script setup>
</script>
<style lang="less">
</style>
